import { constructURL } from 'helpers/url';

// Loads a calendar filter by its ID via an AJAX request and populates the filter form.
//
// @param {number} id - The ID of the calendar filter to load.
// @return {void}
const loadCalendarFilterById = (id) => {
  if (id === undefined || id === null) {
    return false;
  }
  const url = window.calendarSettings?.loadFilterLink.replace('000', id);
  $.ajax({
    url,
    method: 'GET',
    dataType: 'json',
    success(data) {
      $('li.saved-calendar-filter').removeClass('bg-warning');
      $(`li[data-id="${data.id}"]`).addClass('bg-warning');
      $('#calendar_filter_id').val(data.id);
      $('#calendar_filter_title').val(data.title);
      data.patient_ids.forEach((option) => {
        document.querySelector('awc-autocomplete#patient_ids').setValue(option[1], option[0]);
      });
      if (document.querySelector('awc-autocomplete#mode_type_ids')) {
        document.querySelector('awc-autocomplete#mode_type_ids').clear();
        data.mode_type_ids.forEach((option) => {
          document.querySelector('awc-autocomplete#mode_type_ids').setValue(option[1], option[0]);
        });
      }
      if (document.querySelector('awc-autocomplete#therapists_ids')) {
        document.querySelector('awc-autocomplete#therapists_ids').clear();
        data.therapist_ids.forEach((option) => {
          document.querySelector('awc-autocomplete#therapists_ids').setValue(option[1], option[0]);
        });
      }
      window.loadedCalendarFilter = id;
    },
    error(xhr, status, error) {
      console.error('Request failed:', status, error);
    },
  });
};

// Update the quick filter buttons based on pinned filters and the active filter from the URL.
// Ensures the active filter is shown first, even if it isn't pinned.
//
// @return {void}
const updateQuickButtons = () => {
  // Remove any existing quick-buttons container to ensure a fresh render
  document.getElementById('quick-buttons')?.remove();
  // Find the existing header toolbar
  const existingHeaderToolbar = document.querySelector('.fc-header-toolbar.fc-toolbar');
  if (!existingHeaderToolbar) return;
  // Create and insert the new quick-buttons container
  const quickButtonsContainer = document.createElement('div');
  quickButtonsContainer.id = 'quick-buttons';
  quickButtonsContainer.className = 'fc-header-toolbar fc-toolbar';
  existingHeaderToolbar.parentNode.insertBefore(quickButtonsContainer, existingHeaderToolbar.nextSibling);
  // Get the 'filter' parameter from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const activeFilter = urlParams.get('filter'); // Get the filter UUID from the URL
  // Add the button wrapper
  quickButtonsContainer.innerHTML = `<div class='d-flex align-items-center flex-wrap' style='gap: 5px'></div>`;
  const buttonWrapper = quickButtonsContainer.querySelector('.d-flex');
  if (!Array.isArray(window.calendarFiltersData)) return;
  // Get pinned filters
  let pinnedFilters = window.calendarFiltersData.filter(filter => filter.distinction === 'pinned');
  // Check if active filter exists in pinned list
  const activeFilterExists = pinnedFilters.some(filter => filter.id === activeFilter);
  // If active filter isn't pinned, find it and place it at the beginning
  if (activeFilter && !activeFilterExists) {
    const activeFilterObject = window.calendarFiltersData.find(filter => filter.id === activeFilter);
    if (activeFilterObject) {
      pinnedFilters = [activeFilterObject, ...pinnedFilters]; // Prepend active filter
    }
  }
  // Render buttons
  pinnedFilters.forEach(filter => {
    const isActive = filter.id === activeFilter;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `btn btn-sm text-nowrap ${isActive ? 'btn-primary pr-1' : 'btn-light'} m-0`;
    button.dataset.uuid = filter.id;
    button.dataset.active = isActive ? 'true' : 'false';
    button.dataset.default = filter.default;
    button.dataset.action = document.querySelector('admin-calendar') ? 'click->admin-calendar#filterEvents' : 'click->therapist-calendar#filterEvents';
    button.innerHTML = `
      <i class='bi bi-${filter.icon}'></i>
      ${filter.title.length > 30 ? filter.title.substring(0, 27) + '...' : filter.title}
      ${isActive ? "<i class='bi bi-x'></i>" : ''}
    `;
    buttonWrapper.appendChild(button);
  });
};
window.updateQuickButtons = updateQuickButtons;

// Loads calendar filters via an AJAX request and updates the filter lists in the UI.
// Assigns the method to the `window` object for global access.
//
// @return {void}
const loadCalendarFilters = () => {
  $('#filterMask').show();
  const urlParams = new URLSearchParams(window.location.search);
  let filterUrl = `${window.calendarSettings.filtersLink}?${urlParams.toString()}`;
  if (document.querySelector('admin-calendar')) {
    filterUrl += '&admin=true';
  }
  $.ajax({
    url: filterUrl,
    method: 'GET',
    dataType: 'json',
    success(data) {
      const filtersListPinned = $('#calendarFiltersPinnedFilters');
      const filtersListSaved = $('#calendarFiltersSavedFilters');
      const filtersListOther = $('#calendarFiltersTransientFilters');
      // Clear any existing items
      filtersListPinned.empty();
      filtersListSaved.empty();
      filtersListOther.empty();
      // Store the data in windows
      window.calendarFiltersData = data;
      // Loop through the data and create list items
      data.forEach((filter) => {
        if ((filter.admin && window.calendarSettings.isAdmin) || (!filter.admin && !window.calendarSettings.isAdmin)) {
          let distinctionIcon;
          if (filter.distinction === 'transient') {
            distinctionIcon = $('<i>', { class: `filterIcon pr-1 bi bi-${filter.icon}` });
          } else if (filter.distinction === 'pinned') {
            distinctionIcon = $('<i>', { class: `filterIcon pr-1 bi bi-${filter.icon}` });
          } else {
            distinctionIcon = $('<i>', { class: `filterIcon pr-1 bi bi-${filter.icon}` });
          }
          const grippie = $('<i>', { class: 'bi bi-three-dots-vertical grippie' });
          const listItem = $('<li>', { class: 'saved-calendar-filter list-group-item py-1 pl-1 pr-2' }).attr('data-id', filter.id);
          if (filter.active) {
            listItem.addClass('bg-warning');
          }
          const filterSpan = $('<span>', { class: 'loadFilter filter', text: filter.title, dataId: filter.id });
          const defaultIcon = $('<i>', { class: filter.default ? 'bi bi-check-square' : 'bi bi-square' });
          const defaultLink = $('<a>', {
            href: 'javascript:void(0);',
            class: 'defaultFilter',
            dataId: filter.id,
          }).append(defaultIcon);
          const deleteLink = $('<a>', {
            href: 'javascript:void(0);',
            class: 'deleteFilter',
            dataId: filter.id,
          }).append($('<i>', { class: 'bi bi-trash' }));
          listItem.prepend(distinctionIcon);
          listItem.prepend(grippie);
          if (filter.distinction === 'pinned') {
            listItem.append(filterSpan).append(defaultLink).append(deleteLink);
            filtersListPinned.append(listItem);
          } else if (filter.distinction === 'saved') {
            listItem.append(filterSpan).append(defaultLink).append(deleteLink);
            filtersListSaved.append(listItem);
          } else {
            listItem.append(filterSpan);
            filtersListOther.append(listItem);
          }
        }
      });
      // If there are no filters say so
      if (filtersListPinned.children().length === 0) {
        filtersListPinned.append('<li class="text-center text-muted nofilters"><small>No pinned filters</small></li>');
      }
      if (filtersListSaved.children().length === 0) {
        filtersListSaved.append('<li class="text-center text-muted nofilters"><small>No saved filters</small></li>');
      }
      if (filtersListOther.children().length === 0) {
        filtersListOther.append('<li class="text-center text-muted nofilters"><small>No unsaved filters</small></li>');
      }
      $('#filterMask').hide();
      // Reload the loaded filter to make sure we have the right one.
      if (window.loadedCalendarFilter !== undefined) {
        loadCalendarFilterById(window.loadedCalendarFilter);
      }
      // Load quick buttons as defined in the calendar
      window.updateQuickButtons?.();
    },
    error(xhr, status, error) {
      console.error('Unable to load calendar filters:', status, error);
      $('#filterMask').hide();
    },
  });
};
window.loadCalendarFilters = loadCalendarFilters;

// Prepares the UI for creating a new filter by clearing the form inputs.
//
// @param {Event} event - The event object triggering this action.
// @return {void}
const newCalendarFilter = (event) => {
  event?.preventDefault();
  $('li.saved-calendar-filter').removeClass('bg-warning');
  $('#calendarFilterSaveFilter').prop('disabled', false);
  $('#calendar_filter_id').val('');
  $('#calendar_filter_title').val('');
  $('#calendar_filter_quick_button').prop('checked', false);
  document.querySelector('awc-autocomplete#patient_ids').clear();
  document.querySelector('awc-autocomplete#mode_type_ids').clear();
  if (document.querySelector('awc-autocomplete#therapists_ids')) {
    document.querySelector('awc-autocomplete#therapists_ids').clear();
  }
};

// Loads a calendar filter back into the form based on the event's data.
//
// @param {Event} event - The event object containing the filter ID.
// @return {void}
const loadCalendarFilter = (event) => {
  event?.preventDefault();
  newCalendarFilter(event);
  const id = $(event.target).attr('dataid');
  if (id) {
    loadCalendarFilterById(id);
  }
};

// Deletes (demotes to transient) a filter via an AJAX request, after confirming with the user.
//
// @param {Event} event - The event object triggering this action.
// @return {void}
const deleteCalendarFilter = (event) => {
  event?.preventDefault();
  $('#filterMask').show();
  const dUrl = window.calendarSettings?.deleteFilterLink;
  const eId = $(event.target).parent().attr('dataid');
  if (!dUrl || !eId || !window.confirm("You're about to remove this filters saved/pinned status.  Are you sure?")) {
    $('#filterMask').hide();
    return;
  }
  $.ajax({
    url: dUrl.replace('000', eId),
    method: 'POST',
    dataType: 'json',
    success(data) {
      loadCalendarFilters();
      newCalendarFilter();
    },
    error(xhr,status, error) {
      console.error('Request failed:', status, error);
    },
  });
};

// Sets a filter as default via an AJAX request, after confirming with the user.
//
// @param {Event} event - The event object triggering this action.
// @return {void}
const defaultCalendarFilter = (event) => {
  event?.preventDefault();
  $('#filterMask').show();
  const dUrl = window.calendarSettings?.defaultFilterLink;
  const eId = $(event.target).parent().attr('dataid');
  if (!dUrl || !eId || !window.confirm("You're about to toggle this filters default state.  Are you sure?")) {
    $('#filterMask').hide();
    return;
  }
  $.ajax({
    url: dUrl.replace('000', eId),
    method: 'POST',
    dataType: 'json',
    success(data) {
      loadCalendarFilters();
      newCalendarFilter();
    },
    error(xhr,status, error) {
      console.error('Request failed:', status, error);
    },
  });
};

// Send the selected filter to the server so it can save it and then reload the UI with that filter selected
//
// @param {Event} event - The event object triggering this action.
// @return {void}
const saveAndApplyCalendarFilter = (event) => {
  event?.preventDefault();
  // Get the form element
  const form = document.getElementById('caseload-new-form');
  // Check if the form is valid before proceeding
  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }
  $('#calendarFiltersSaveAndApplyFilter').prop('disabled', true);
  const saveUrl = window?.calendarSettings?.saveFilterLink;
  $.ajax({
    url: saveUrl,
    method: 'POST',
    dataType: 'json',
    data: $(form).serialize(),
    success(data) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('filter'); // Remove the "filter" param
      urlParams.set('filter', data.id); // Add or update the "filter" param
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      Turbolinks.controller.disable();
      window.location.assign(newUrl);
    },
    error(xhr, status, error) {
      // This happens because the filter is empty! So just refresh which is fine.
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('filter'); // Remove the "filter" param
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      Turbolinks.controller.disable();
      window.location.assign(newUrl);
    },
  });
};

// Update the filter's position on the server after a drag-and-drop change, then reload the calendar filters.
//
// @param {Object} ui - The jQuery UI object representing the moved filter.
// @param {string} list - The list type ('transient' or other).
// @return {void}
const saveFilterPositionChange = (ui, list) => {
  $('#filterMask').show();
  const filterItems = ui.item.parent().children('.saved-calendar-filter');
  const uuid = ui.item.data('id');
  const index = list === 'transient' ? 0 : filterItems.index(ui.item);
  let moveUrl = window?.calendarSettings?.moveFilterLink;
  moveUrl = moveUrl.replace('A', uuid).replace('B', index).replace('C', list);
  $.ajax({
    url: moveUrl,
    method: 'PATCH',
    dataType: 'json',
    success(data) {
      loadCalendarFilters();
    },
    error(xhr,status, error) {
      console.error('Request failed:', status, error);
    },
  });
};

// Show or hide empty drop zones in filter lists based on the provided state.
// If showing, ensures each section has a placeholder if no filters exist.
// If hiding, removes all drop zone placeholders.
//
// @param {boolean} show - Whether to show or hide the empty drop zones.
// @param {string|null} src - The source list being modified ('pinned', 'saved', 'transient').
// @return {void}
const showEmptyDropzones = (show, src = null) => {
  if (show) {
    const pinnedFilters = $('#calendarFiltersPinnedFilters li.saved-calendar-filter').length;
    if ((src !== 'pinned' && pinnedFilters === 0) || (src === 'pinned' && pinnedFilters === 1)) {
      $('#calendarFiltersPinnedFilters').append('<li class="drop-zone text-muted"><small>Pinned filters</small></li>');
    }
    const savedFilters = $('#calendarFiltersSavedFilters li.saved-calendar-filter').length;
    if ((src !== 'saved' && savedFilters === 0) || (src === 'saved' && savedFilters === 1)) {
      $('#calendarFiltersSavedFilters').append('<li class="drop-zone text-muted"><small>Saved filters</small></li>');
    }
    const otherFilters = $('#calendarFiltersOtherFilters li.saved-calendar-filter').length;
    if ((src !== 'transient' && otherFilters === 0) || (src === 'transient' && otherFilters === 1)) {
      $('#calendarFiltersOtherFilters').append('<li class="drop-zone text-muted"><small>Unsaved filter</small></li>');
    }
    $('.filterListCard').addClass('no-overflow');
    $('.nofilters').addClass('hidden');
  } else {
    $('#calendarFiltersPinnedFilters .drop-zone').remove();
    $('#calendarFiltersSavedFilters .drop-zone').remove();
    $('#calendarFiltersOtherFilters .drop-zone').remove();
    $('.filterListCard').removeClass('no-overflow');
    $('.nofilters').removeClass('hidden');
  }
};

// Registers event listeners for various UI interactions related to filters and initializes the filters.
//
// @return {void}
window.registerFilters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  window.loadedCalendarFilter = urlParams.get('filter');
  loadCalendarFilters();
  $(document).off('.calendar');
  $(document).on('click.calendar', '#calendarFiltersSaveAndApplyFilter', saveAndApplyCalendarFilter);
  $(document).on('click.calendar', '#calendarFilterNewFilter', newCalendarFilter);
  $(document).on('click.calendar', 'span.loadFilter', loadCalendarFilter);
  $(document).on('click.calendar', 'a.deleteFilter', deleteCalendarFilter);
  $(document).on('click.calendar', 'a.defaultFilter', defaultCalendarFilter);
  $(document).on('click.calendar', '[data-bs-dismiss="modal"]', function () {
    $(this).closest('.modal').modal('hide');
  });

  // If we are in the admin area, and we don't have a filter set then we need to pop the filter modal
  if (document.querySelector('admin-calendar') && window.loadedCalendarFilter == null) {
    $('.filter-required-warning').removeClass('hidden');
    $('#calendarFilters').modal('show');
  }

  // Below we hook up the dragging of filters to save or pin them.
  // From the transient filters to saved or pinned.
  $('#calendarFiltersTransientFilters').sortable({
    connectWith: '#calendarFiltersSavedFilters, #calendarFiltersPinnedFilters', // Can send items to Saved Filters
    revert: true, // Revert if dropped in the same list
    handle: '.grippie',
    placeholder: 'dragging',
    helper: 'clone',
    axis: 'y',
    opacity: 0.8,
    start(event, ui) {
      showEmptyDropzones(true, 'transient');
      ui.item.data('originalIndex', ui.item.index());
    },
    receive(event, ui) { // called when we are dropped on
      saveFilterPositionChange(ui, 'transient');
    },
    update(event, ui) {
      // do nothing.
    },
    stop(event, ui) {
      // If we are dragging/dropping fromtransient to transient, don't update.
      const originalIndex = ui.item.data('originalIndex');
      if (ui.item.parent().attr('id') === 'calendarFiltersTransientFilters') {
        $(this).sortable('cancel');
        const items = $(this).children();
        if (originalIndex >= 0 && originalIndex < items.length) {
          items.eq(originalIndex).before(ui.item);
        }
      }
      showEmptyDropzones(false);
    },
  });

  // From the saved filters to transient or pinned
  $('#calendarFiltersSavedFilters').sortable({
    connectWith: '#calendarFiltersTransientFilters, #calendarFiltersPinnedFilters',
    revert: false,
    handle: '.grippie',
    placeholder: 'dragging',
    axis: 'y',
    opacity: 0.8,
    start(event, ui) {
      showEmptyDropzones(true,'saved');
    },
    receive(event, ui) { // called when we are dropped on
      saveFilterPositionChange(ui, 'saved');
    },
    update(event, ui) { // called when we reorder within same list
      saveFilterPositionChange(ui, 'saved');
    },
    stop(event, ui) {
      showEmptyDropzones(false);
    },
  });

  // From the pinned filters to transient or saved
  $('#calendarFiltersPinnedFilters').sortable({
    connectWith: '#calendarFiltersTransientFilters, #calendarFiltersSavedFilters',
    revert: false,
    handle: '.grippie',
    placeholder: 'dragging',
    axis: 'y',
    opacity: 0.8,
    start(event, ui) {
      showEmptyDropzones(true,'pinned');
    },
    receive(event, ui) { // called when we are dropped on
      saveFilterPositionChange(ui, 'pinned');
    },
    update(event, ui) { // called when we reorder within same list
      saveFilterPositionChange(ui, 'pinned');
    },
    stop(event, ui) {
      showEmptyDropzones(false);
    },
  });
};
